export const contentTableConfig = {
  title: '渠道报表',
  propList: [
    {prop: 'channelName', label: '所属渠道', minWidth: '80', align: 'left'},
    {prop: 'belongDate', label: '日期', minWidth: '80', align: 'left', sortable: true},
    {prop: 'resourcesCount', label: '资源量', minWidth: '80', align: 'left', sortable: true},
    {prop: 'repeatCount', label: '重复量', minWidth: '80', align: 'left', sortable: true},
    {prop: 'deleteCount', label: '删除量', minWidth: '80', align: 'left', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
